import React, { useEffect, useState } from 'react';
import './webinar.css';
import { IconButton, Tooltip, withStyles } from '@material-ui/core';
import WebSideBar from './webSideBar';
import DocumentPopup from '../popups/documentPopup/documentPopup';
import { setWebinarData, setWebinarSocket, setWebinarUserToVC } from '../../store/actions/webinarActions';
import { connect } from 'react-redux';
import DisplayEmojis from './displayEmoji';
import PropTypes from 'prop-types';
import WebinarMeetInfo from '../popups/webinarMeetingInfo/webinarMeetInfo';
import { withRoomContext } from '../../RoomContext';
import io from 'socket.io-client';
import { useHistory } from 'react-router-dom';
import NewPollingDialog from './..//MeetingDrawer/polling/pollingDialog/newPollDialog';
import * as toolareaActions from '../../store/actions/toolareaActions';
import * as roomActions from '../../store/actions/roomActions';
import Badge from '@material-ui/core/Badge';
import * as chatActions from '../../store/actions/chatActions';
import WebinarVcJoinDialog from '../webinarVcJoinDialog';
// import Player from './player';
import Player from './newPlayer';
import { webinarEmoji } from '../../libs/apis/webinarAnalyticsAPI';
import { store } from '../../store/store';
import { useIntl } from 'react-intl';

const StyledBadge = withStyles((theme) => ({
	badge : {
		top        : 10,
		// border  : `2px solid red`,
		padding    : '0px',
		background : 'red'
	}
}))(Badge);

const WebinarVc=(props) =>
{

	const { webinarData, webinarStreamOn, webinarSocket, handlePollingData, handleSubmitPollData, setData,
		isPollOpen, currentPollingData, roomClient, toggleToolArea, setToolTab, setStream,	unreadChat,	setRemoveCount, setVc, moveToVc, me, handlePollingDialogue
	}=props;

	const [ open, setOpen ] = useState(false);
	const [ sideComp, setSideComp ] = useState('');
	const [ emojiTab, setEmojiTab ] = useState(false);
	const [ openDoc, setOpenDoc ]=useState(false);
	const emojisList = [ 'emoji1', 'emoji2', 'emoji3', 'emoji4', 'emoji5', 'emoji6', 'emoji7' ];
	const [ webinarInfo, setWebinarInfo ]=useState(false);

	const navigate = useHistory();
	const intl = useIntl();

	const [ emojiValue, setEmojiValue ]=useState([]);
	const [ emojiClickDisable, setEmoiClickDisable ] = useState(false);

	const handlePollOpen = () =>
	{
		setOpen(true);
		setEmojiTab(false);
		setSideComp('poll');
	};
	const handleQaOpen = () =>
	{
		setOpen(true);
		setEmojiTab(false);
		setSideComp('qa');
	};
	const handleChatOpen = () =>
	{
		setOpen(true);
		setEmojiTab(false);
		setSideComp('chat');
	};
	const handlespeakerOpen = () =>
	{
		setOpen(true);
		setEmojiTab(false);
		setSideComp('speaker');
	};

	// Function to handle closing the drawer
	const handleClose = () =>
	{
		setOpen(false);
		setSideComp('');
		toggleToolArea();
		setToolTab('');
	};
	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;

	const meetingId = parameters.get('id');
	const userId = sessionStorage.getItem('uid');

	const sessionId = parameters.get('sessionId');

	const handleDocPop = () =>
	{
		setOpenDoc(!openDoc);
		setEmojiTab(false);
		// setAnchorQuadEl(null);
	};

	// useEffect(() =>
	// {
	// const socketURI = import.meta.env.VITE_WEBINAR_SOCKET;

	// 	const webinarSocketConnection = io.connect(`${socketURI}`);

	// 	webinarSocketConnection.emit('room', webinarData.sessionId, '80925', 'surya', 'webinarUser');

	// 	setWebinarSocket(webinarSocketConnection);
	// }, []);

	useEffect(() =>
	{
		if (webinarSocket === undefined || webinarSocket === null)
		{
			navigate.push(`/welcome?id=${localStorage.getItem('meetingId')}&sessionId=${localStorage.getItem('sessionId')}&uid=${localStorage.getItem('broadcastUserId')}&name=${localStorage.getItem('broadcastUserName')}`);
		}
		else
		{

			// console.log('flkasjiof', webinarSocket);

			// webinarSocket && webinarSocket.on('notification', async (notification) =>
			// {
			// 	console.log(
			// 		'socket "notification" event [method:"%s", data:"%o"]',
			// 		notification.method, notification.data);

			// 	try
			// 	{
			// 		switch (notification.method)
			// 		{
			// 			case 'get-message':
			// 			{
			// 				const { data } = notification.data;

			// 				console.log('datat', data);
			// 				roomClient.updateSocketChat(data);
			// 				break;
			// 			}

			// 			case 'webinarStreamOn':
			// 			{
			// 				const { data } = notification.data;

			// 				console.log('socket emitted webinarStreamOn', data, notification.data);
			// 				setStream(notification.data.stream);
			// 				break;
			// 			}
			// 			case 'moveToVC':
			// 			{
			// 				// const { data } = notification.data;

			// 				console.log('socket emitted MoveToVC', notification.data);
			// 				setVc(true);
			// 				break;
			// 			}
			// 			case 'removeUser':
			// 			{
			// 				window.location.href = import.meta.env.VITE_config;
			// 				break;
			// 			}
			// 			case 'get-emoji':
			// 			{
			// 				const { data } = notification.data;

			// 				const updateEmoji=[ ...emojiValue, data ];

			// 				setEmojiValue(updateEmoji);
			// 				break;
			// 			}
			// 			case 'setPollingRequest':
			// 			{
			// 				const { pollingData } = notification.data;

			// 				console.log('dioajkdjioa', pollingData, notification.data);

			// 				handlePollingData(pollingData);
			// 				break;
			// 			}
			// 			case 'setPeerPollSubmitList':
			// 			{
			// 				const { data } = notification.data;

			// 				console.log('socket emitted webinarStreamOn', data);
			// 				handleSubmitPollData(data);
			// 				break;
			// 			}
			// 			case 'moderator:closeMeeting':
			// 			{
			// 				const { data } = notification.data;

			// 				console.log('socket emitted webinarStreamOn', data);
			// 				navigate.push('/hostEndedWebinar', { state: data.exitUrl });
			// 				break;
			// 			}
			// 			default:
			// 			{
			// 				console.log(
			// 					'unknown notification.method "%s"', notification.method);
			// 			}
			// 		}
			// 	}
			// 	catch (error)
			// 	{
			// 		console.log('error on socket "notification" event [error:"%o"]', error);
			// 	// store.dispatch(requestActions.notify(
			// 	// 	{
			// 	// 		type : 'error',
			// 	// 		text : intl.formatMessage({
			// 	// 			id             : 'socket.requestError',
			// 	// 			defaultMessage : 'Error on server request'
			// 	// 		})
			// 	// 	}));
			// 	}
			// });

			webinarSocket && webinarSocket.on('connect', (d) =>
			{
				console.log('connnnnnnnnnnnnnnn', d);
				webinarSocket.emit('room', me.id, webinarData.sessionId, userId, me.name, 'webinarUser', webinarData?._id, store.getState().settings.countryName, store.getState().settings.countryCode, function(data)
				{
					console.log('data', data);
					if (data.method==='UserExist')
					{
						// setUserExist('You are already part of the webinar.');
					}
					else if (data.method==='NotFound')
					{
						console.log('ddddddddd');
					}
					else
					{
						// if (data.stream)
						// {
						// 	setStream(data.stream);
						// }
						// navigate.push(`/join-webinar?id=${parameters.get('id')}&sessionId=${parameters.get('sessionId')}&uid=${userId}&name=${displayName}`);
					}
				});
			});

			webinarSocket && webinarSocket.on('reconnect', (d) =>
			{
				console.log('reconnnnnnnnnnnnnnnn', d);
			});

			webinarSocket && webinarSocket.on('webinarStreamOn', (data) =>
			{
				setStream(data.stream);
			});

			webinarSocket && webinarSocket.on('get-emoji', (data) =>
			{
				const updateEmoji = [ ...emojiValue, { id: Date.now(), emoji: data } ];

				// const updateEmoji = [ ...emojiValue, { id: Date.now(), emoji: data, status: 'active' } ]; 

				setEmojiValue(updateEmoji);
			});

			webinarSocket && webinarSocket.on('get-message', (data) =>
			{
				roomClient.updateSocketChat(data);
			});

			webinarSocket && webinarSocket.on('reply-message', (data) =>
			{
				roomClient.updateSocketChat(data);
			});

			webinarSocket && webinarSocket.on('setPollingRequest', (data) =>
			{
				handlePollingData(data);
			});

			webinarSocket && webinarSocket.on('setPeerPollSubmitList', (data) =>
			{
				handleSubmitPollData(data);
			});

			webinarSocket && webinarSocket.on('moderator:closeMeeting', (data) =>
			{
				navigate.push('/hostEndedWebinar', { state: data });
			});

			webinarSocket && webinarSocket.on('moveToVC', (data) =>
			{
				console.log('Move to webinarVc', data);
				window.location.href=`${import.meta.env.VITE_config}inconf/${webinarData._id}/${window.btoa('webinar')}`;
				// setVc(true);
			});

			webinarSocket && webinarSocket.on('removeUser', (data) =>
			{
				window.location.href = import.meta.env.VITE_config;
			});

			webinarSocket && webinarSocket.on('engagementActions', (data) =>
			{

				const newData={ ...webinarData, ...data };

				setData(newData);

				if (!data?.polls)
				{
					handlePollingDialogue(false);
				}

			});
		}

		return () =>
		{
			if (webinarSocket)
			{
				webinarSocket.off('webinarStreamOn');
				webinarSocket.off('get-emoji');
				webinarSocket.off('get-message');
				webinarSocket.off('setPollingRequest');
				webinarSocket.off('setPeerPollSubmitList');
				webinarSocket.off('moderator:closeMeeting');
				webinarSocket.off('moveToVC');
				webinarSocket.off('reply-message');
				webinarSocket.off('removeUser');
				webinarSocket.off('engagementActions');
			}
		};

	}, [ webinarSocket, webinarData ]);

	const handleExit=() =>
	{
		window.location.href = import.meta.env.VITE_config;
	};

	const handleWebinarEmoji = (emojiSelected) =>
	{
		setEmoiClickDisable(true);
		setTimeout(async () =>
		{
			const body = {
				licenseTo    : webinarData?.licenseTo,
				meetingId    : webinarData?.meetingInfoId,
				scheduleType : webinarData?.scheduleType,
				sessionId    : webinarData?.sessionId,
				scheduledBy  : webinarData?.scheduledBy,
				startTimeUTC : webinarData?.startTimeUTC,
				endTimeUTC   : webinarData?.endTimeUTC,
				emojiType    : emojiSelected
			};

			await webinarEmoji(body);
			setEmoiClickDisable(false);
		}, 500);
	};

	// const trueCount = [ webinarData.polls, webinarData.resources, webinarData.reactions, webinarData.liveQandA, webinarData.chat ].filter(Boolean).length;

	return (
		<div className='flexCol fullH webVcpage'>
			<div className='flexRow webHead' >
				<Tooltip title={intl.formatMessage({ id: 'info', defaultMessage: 'info' })} className='pointer'>
					<img src='/icons/info.svg' alt='info' onClick={() => setWebinarInfo(true)} />
				</Tooltip>
			</div>
			<div className='flexMinWidthCol aCntr jCntr webBody' >
				<div className='flexAuto frameBdy pRel'>
					{/* <iframe width='100%' height='100%' title='liveStream' frameBorder='0' style={{ borderRadius: '8px' }} src={`https://webinar.invc.vc/LiveApp/play.html?name=${sessionId}&playOrder=hls`} allow='fullscreen; speaker' /> */}
					<Player sessionId={sessionId} />
				</div>
			</div>
			{/* <div className={`flexRow jCntr webBar ${trueCount < 3 && 'webBar1'}`} > */}
			<div className='flexRow jCntr webBar' >
				{webinarStreamOn && webinarData.polls && <div className='flexAutoCol aCntr pdngXS pointer' onClick={handlePollOpen}>
					<img src='/webinar/polls.svg' alt='poll' />
					<small className='wTxt' >Poll</small>
				</div>}
				{webinarStreamOn && webinarData.resources && <div className='flexAutoCol aCntr pdngXS pointer' onClick={handleDocPop}>
					<img src='/webinar/res.svg' alt='poll' />
					<small className='wTxt' >Document</small>
				</div>}
				{/* { webinarStreamOn && webinarData.liveQandA && <div className='flexAutoCol aCntr pdngXS pointer' onClick={handleQaOpen}>
					<img src='/webinar/qna.svg' alt='poll' />
					<small className='wTxt' >Q&A</small>
				</div>} */}
				{webinarStreamOn && webinarData.reactions && <div className='flexAutoCol aCntr pdngXS pointer pRel' onClick={() => setEmojiTab(!emojiTab)}>
					<img src='/webinar/emoji.svg' alt='poll' />
					<small className='wTxt' >Emoji</small>
					{emojiTab &&
					<div className='flexAutoRow pdngSM gap8 emojPop'>
						{emojisList.map((each, index) => (
							<IconButton
								key={index}
								size='small'
								disabled={emojiClickDisable}
								onClick={
									() =>
									{
										handleWebinarEmoji(each);
										// setEmojiValue([ ...emojiValue, each ]);
										webinarSocket.emit('send-emoji', webinarData.sessionId, each);
										// roomClient.animeEmoji(each, meId); setOpenEmoji(false);
									}
								}
							>
								{
									<img src={`./emojis/${each}.svg`} className='emoImg' alt={each} />
								}
							</IconButton>
						))}
					</div>
					}
				</div>}

				{webinarStreamOn && webinarData.chat &&
					<div className='flexAutoCol aCntr pdngXS pointer' onClick={() => { handleChatOpen(); setRemoveCount(); }}>
						<StyledBadge max={99999} badgeContent={unreadChat}>
							<img src='/webinar/chat1.svg' alt='poll' />
						</StyledBadge>

						<small className='wTxt' >Chat</small>
					</div>
				}
				<div className='flexAutoCol aCntr pdngXS pointer' onClick={handleExit}>
					<img src='/icons/end.svg' alt='poll' />
					<small className='wTxt' >Leave</small>
				</div>
			</div>
			<WebSideBar open={open} sideComp={sideComp} setSideComp={setSideComp} handleClose={handleClose} />
			{openDoc && <DocumentPopup open={openDoc} setOpen={setOpenDoc}/>}
			{moveToVc && <WebinarVcJoinDialog joinOpen={moveToVc}/>}
			{webinarInfo && <WebinarMeetInfo webinarData={webinarData} handlespeakerOpen={handlespeakerOpen} open={webinarInfo} setOpen={setWebinarInfo}/>}
			{emojiValue && emojiValue.length>0 && <DisplayEmojis emojiValue={emojiValue} setEmojiValue={setEmojiValue} />}
			{webinarStreamOn && currentPollingData && isPollOpen && webinarData?.polls &&
					currentPollingData?.isActive &&
					<NewPollingDialog currentPollingData={currentPollingData} openDialog />}
		</div>
	);
};

WebinarVc.propTypes =
{
	webinarData           : PropTypes.any,
	setData               : PropTypes.func,
	webinarSocket         : PropTypes.any,
	setWebinarSocket      : PropTypes.any,
	handlePollingData     : PropTypes.func,
	handleSubmitPollData  : PropTypes.func,
	isPollOpen            : PropTypes.bool,
	currentPollingData    : PropTypes.object,
	roomClient            : PropTypes.any,
	setToolTab            : PropTypes.func,
	toggleToolArea        : PropTypes.func,
	setStream             : PropTypes.func,
	webinarStreamOn       : PropTypes.any,
	moveToVc              : PropTypes.any,
	setVc                 : PropTypes.any,
	unreadChat            : PropTypes.any,
	setRemoveCount        : PropTypes.func,
	handlePollingDialogue : PropTypes.func,
	me                    : PropTypes.any
};

const makeMapStateToProps = () =>
{

	const mapStateToProps = (state) =>
		({
			webinarData        : state.webinar.webinarData,
			webinarSocket      : state.webinar.webinarSocket,
			isPollOpen         : state.toolarea.isPollOpen,
			currentPollingData : state.toolarea.currentPollingData,
			webinarStreamOn    : state.room.webinarStreamOn,
			unreadChat         : state.chat.countBroadcastUnread,
			moveToVc           : state.webinar.moveToVc,
			me                 : state.me
		});

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setData : (webinarData) =>
		{
			dispatch(setWebinarData(webinarData));
		},
		setWebinarSocket : (socketVal) =>
		{
			dispatch(setWebinarSocket(socketVal));
		},
		handlePollingData : (poolData) =>
		{

			dispatch(toolareaActions.handlePollingDialogue(true));
			dispatch(toolareaActions.handlePollings(poolData));
		},
		handleSubmitPollData : (peerPollSubmitData) =>
		{

			dispatch(toolareaActions.peerPollSubmitList(peerPollSubmitData));
		},
		setToolTab : (tab) =>
			dispatch(toolareaActions.setToolTab(tab)),
		toggleToolArea : () =>
		{
			dispatch(toolareaActions.toggleToolArea());
		},
		setStream : (streamVal) =>
		{
			dispatch(roomActions.setWebinarStreamOn({ webinarStreamOn: streamVal }));
		},
		setVc : (moveToVc) =>
		{
			dispatch(setWebinarUserToVC(moveToVc));
		},
		setRemoveCount : () =>
		{
			dispatch(chatActions.removeBroadcastCount());
		},
		handlePollingDialogue : (isPollOpen) => dispatch(toolareaActions.handlePollingDialogue(isPollOpen))
	};
};

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.webinarData === next.webinar.webinarData &&
				prev.webinar.webinarSocket === next.webinar.webinarSocket &&
				prev.toolarea.currentPollingData === next.toolarea.currentPollingData &&
				prev.toolarea.isPollOpen === next.toolarea.isPollOpen &&
				prev.room.webinarStreamOn === next.room.webinarStreamOn &&
				prev.webinar.moveToVc === next.webinar.moveToVc &&
				prev.chat === next.chat &&
				prev.me.id === next.me.id
			);
		}

	}
)(WebinarVc));
